import { render, staticRenderFns } from "./scraping.vue?vue&type=template&id=621b4a36"
import script from "./scraping.vue?vue&type=script&lang=js"
export * from "./scraping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports